import React from 'react';

import { DEFAULT_SIZE } from './Base.constants';
import * as S from './Base.styles';

export const Base = ({
  children,
  description,
  header,
  size = DEFAULT_SIZE,
  title,
  top,
  ...rest
}) => {
  const hasChildren = Boolean(children);
  const hasDescription = Boolean(description);
  const hasHeader = Boolean(header);
  const hasTitle = Boolean(title);
  const hasTop = Boolean(top);

  return (
    <S.Container size={size} {...rest}>
      {(hasDescription || hasHeader || hasTitle || hasTop) && (
        <S.TopContainer>
          {top}
          {(hasHeader || hasTitle) && (
            <S.TopWrapper>
              {hasTitle && <S.Title>{title}</S.Title>}
              {hasHeader && <S.Header>{header}</S.Header>}
            </S.TopWrapper>
          )}
          {hasDescription && <S.Description>{description}</S.Description>}
        </S.TopContainer>
      )}
      {hasChildren && <S.Content>{children}</S.Content>}
    </S.Container>
  );
};
